<template>
  <div
    class="yh-caret"
    :class="order"
    @click="handleSortClick"
  >{{sort.label}}
    <span class="caret-wrapper">
      <i
        class="sort-caret ascending"
        @click.stop="toggle(2)"
      ></i><i
        class="sort-caret descending"
        @click.stop="toggle(1)"
      ></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'YhCaret',
  props: {
    sort: Object,
  },
  data() {
    return {
      sortMap: {
        0: '',
        1: 'descending',
        2: 'ascending',
      },
    };
  },
  computed: {
    order() {
      // 返回 '' 'descending' 'ascending'
      return this.sortMap[this.sort.order % 3];
    },
  },
  methods: {
    handleSortClick() {
      // 组件会直接修改父组件数据，非最佳实践，但是有效
      this.sort.order += 1;
      this.$emit('click', this.order);
    },
    toggle(order) {
      // 保持与 element ui 的行为一致
      if (this.sort.order % 3 === 0) {
        this.sort.order = order;
      } else {
        this.sort.order = 0;
      }
      this.$emit('click', this.order);
    },
  },
};
</script>

<style scoped>
.yh-caret {
  padding-left: 0;
}
</style>
